import React from 'react';
import {
  Checkbox,
  CheckboxGroup,
  Flex,
  FormControl,
  FormLabel,
  Stack,
} from '@chakra-ui/react';

export type FormControlCheckBoxOption = {
  value: string;
  label: string;
};

export interface IFormControlCheckBoxGroup {
  name: string;
  form?: any;
  label?: string;
  options: FormControlCheckBoxOption[];
  className?: string;
  gap?: string;
  direction?: 'row' | 'column';
  onChange?: (values: string[]) => void;
  onFocus?: () => void;
  disabled?: boolean;
}

const FormControlCheckBoxGroup: React.FC<IFormControlCheckBoxGroup> = ({
  name,
  form,
  label,
  options,
  className,
  gap = '12px',
  direction = 'row',
  onChange,
  onFocus,
  disabled = false,
}) => {
  const values: string[] = Array.isArray(form?.values?.[name])
    ? form.values[name]
    : [];

  const handleChange = (next: (string | number)[]) => {
    const nextValues = next.map(String);
    onFocus?.();
    if (form && !onChange) {
      form.setFieldValue(name, nextValues);
      form.setFieldTouched(name, true);
      return;
    }
    onChange?.(nextValues);
  };

  return (
    <FormControl className={`form-control-checkbox-group ${className ?? ''}`}>
      <Flex direction="column" gap={gap}>
        {label ? <FormLabel>{label}</FormLabel> : null}
        <CheckboxGroup value={values} onChange={handleChange}>
          <Stack
            className="language-options"
            direction={direction}
            spacing={4}
            flexWrap="wrap"
          >
            {options.map((option) => (
              <Checkbox
                key={option.value}
                value={option.value}
                isDisabled={disabled}
                onFocus={onFocus}
              >
                {option.label}
              </Checkbox>
            ))}
          </Stack>
        </CheckboxGroup>
      </Flex>
    </FormControl>
  );
};

export default FormControlCheckBoxGroup;
